import { AudioRecordingRepository } from "@/domains/dexie-db/repositories/audio-recording/audio-recording";
import {
  AudioRecordingRef,
  AudioUploadErrorRef,
  AudioUploadPersistence,
} from "@/store/audio/uploading/audio-uploading.types";

type RecordingStatusAudioUploadPersistenceConfig = {
  recordings: AudioRecordingRepository;
};

/**
 * Persists recording-level upload state that applies across recording strategies.
 */
export class RecordingStatusAudioUploadPersistence implements AudioUploadPersistence {
  protected readonly recordings: AudioRecordingRepository;

  constructor({ recordings }: RecordingStatusAudioUploadPersistenceConfig) {
    this.recordings = recordings;
  }

  async markAsUploading({ audioRecordingId }: AudioRecordingRef): Promise<void> {
    await this.recordings.markAsUploading({ id: audioRecordingId });
  }

  async markAsUploadCompleted({ audioRecordingId }: AudioRecordingRef): Promise<void> {
    await this.recordings.markAsUploadCompleted({ id: audioRecordingId });
  }

  async markAsUploadErrored({
    audioRecordingId,
    errorMessage,
    uploadStage,
    forceRestart,
    debugInfo,
    failureKind,
  }: AudioUploadErrorRef): Promise<void> {
    await this.recordings.markAsUploadErrored({
      id: audioRecordingId,
      errorMessage,
      uploadStage,
      forceRestart,
      debugInfo,
      failureKind,
    });
  }
}
